import { render } from "./CampaignPopup.vue?vue&type=template&id=395c9ebc&scoped=true"
import script from "./CampaignPopup.vue?vue&type=script&lang=ts"
export * from "./CampaignPopup.vue?vue&type=script&lang=ts"

import "./CampaignPopup.vue?vue&type=style&index=0&id=395c9ebc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-395c9ebc"

export default script
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QExpansionItem,QForm,QField,QIcon});
